
  @if (viewOnly && answer) {
    <div class="flex flex-col gap-4 break-words">
      @for (answer of previewAnswer; track answer) {
        <b>{{answer.key}}</b>
        <div class="flex flex-col gap-4 min-h-20 rounded border border-gray-200 p-2">
            @for (item of answer.items; track item) {
              <div class="cursor-pointer bg-gray-100 min-h-20 p-2 rounded border border-gray-100 hover:border-gray-200">{{item}}</div>
            }
            @empty {
            <p class="cursor-pointer">No items</p>
          }
        </div> 
       }      
    </div>
  }
  @else {
    <div cdkDropListGroup
      class="grid gap-12 break-words"
      style="grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));"
      >
      <div class="flex flex-col gap-4 break-words">
        <b>All Items</b>
        <div
          cdkDropList
          [cdkDropListData]="allItems"
          class="flex flex-col gap-4 min-h-20 rounded border border-gray-200 p-2"
          (cdkDropListDropped)="drop($event)">
          @for (item of allItems; track item) {
            <div class="cursor-pointer bg-gray-100 min-h-20 p-2 rounded border border-gray-100 hover:border-gray-200" cdkDrag>{{item}}</div>
          }
        </div>
      </div>

      @for (group of allGroups; track group) {
        <div class="flex flex-col gap-4 break-words">
          <b>{{group.formatted}}</b>
          <div
            class="flex flex-col gap-4 min-h-20 rounded border border-gray-200 p-2"
            cdkDropList
            [cdkDropListData]="group.items"
            (cdkDropListDropped)="drop($event)">
            @for (item of group.items; track item) {
              <div class="cursor-pointer bg-gray-100 min-h-20 p-2 rounded border border-gray-100 hover:border-gray-200" cdkDrag>{{item}}</div>
            }
            @empty {
            <p class="cursor-pointer">No items</p>
          }
        </div>
      </div>
    }
    </div>
  }